<script>
export default {
    name: 'IconCentre'
}
</script>
<template>
    <svg
        class="base-icon icon-centre"
        width="64"
        height="64"
        viewBox="0 0 64 64"
        xmlns="http://www.w3.org/2000/svg"
    >
        <path
            d="M16 8h32v16h8v32H8V24h8V8zm4 4h24v40H20V12zm6 24h12v16H26V36zm22 0h4v4h-4v-4zm0 8h4v4h-4v-4zm-36-8h4v4h-4v-4zm4 8v4h-4v-4h4zm16-28c3.314 0 6 2.223 6 4.965V32h-4.333v-4.414h-3.333V32h-4.333L26 20.965C26 18.223 28.687 16 32 16zm0 3.586c-.92 0-1.666.618-1.666 1.38v3.31h3.333v-3.31c0-.762-.746-1.38-1.666-1.38z"
            fill="currentColor"
            fill-rule="evenodd"
        />
    </svg>
</template>
